import "./Loading.css";
import logo from "../../../assets/images/Logo.webp";

const LoadingOverlay = ({ show }) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <img src={logo} alt="logo" />
      <div className="spinner" />
    </div>
  );
};

export default LoadingOverlay;
